const STATUS_CONFIG = {
  draft: {
    display: 'Draft',
    className: 'status-tag--gray-reverse',
  },
  sent: {
    display: 'Sent',
    className: 'status-tag--gold-outline',
  },
  published: {
    display: 'Published',
    className: 'status-tag--gold-outline',
  },
  unpublished_changes: {
    display: 'Unpublished Changes',
    className: 'status-tag--red-outline',
  },
  viewed: {
    display: 'Viewed',
    className: 'status-tag--gold-outline',
  },
  accepted: {
    display: 'Accepted',
    className: 'status-tag--gray-outline',
  },
  closed: {
    display: 'Closed',
    className: 'status-tag--gray-outline',
  },
  expired: {
    display: 'Expired',
    className: 'status-tag--red-outline',
  },
  overdue: {
    display: 'Past Due',
    className: 'status-tag--red-outline',
  },
  partially_paid: {
    display: 'Partially Paid',
    className: 'status-tag--gold-outline',
  },
  paid: {
    display: 'Paid in Full',
    className: 'status-tag--gray-outline',
  },
};

const StatusIndicator = ({ status }) => {
  const config = STATUS_CONFIG[status];

  if (!config) return null;

  return (
    <div className={`status-tag ${config.className}`}>
      {config.display}
    </div>
  );
};

export default StatusIndicator;
